// extracted by mini-css-extract-plugin
export var player = "VideoEmbed-module--player--cf22f";
export var video = "VideoEmbed-module--video--70938";